import { Component, inject, OnInit } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule, NgClass } from '@angular/common';
import { ResponsiveHelperComponent } from './shared/components/responsive-helper/responsive-helper.component';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { primeNgTranslation } from './core/constants/primeNgTranslation';
import { IdleService } from './core/services/idle.service';
import { SessionModalComponent } from './shared/components/session-modal/session-modal.component';
import { globalConfig } from './core/utils/globalConfig';
import { AuthService } from './modules/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [CommonModule, NgClass, RouterOutlet, ResponsiveHelperComponent, ToastModule, SessionModalComponent],
  providers: [MessageService],
})
export class AppComponent implements OnInit {
  router = inject(Router);
  title = 'Tolis';
  showModal = false;
  countdown = 0;

  constructor(
    public themeService: ThemeService,
    private primengConfig: PrimeNGConfig,
    private idleService: IdleService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.primengConfig.zIndex = {
      modal: 1100, // dialog, sidebar
      overlay: 1200, // dropdown, overlaypanel
      menu: 1200, // overlay menus
      tooltip: 1100, // tooltip
    };
    this.primengConfig.setTranslation(primeNgTranslation);

    if (sessionStorage.getItem(globalConfig.tokenApi)) {
      this.idleService.startWatching();
    } else {
      this.idleService.stopWatching();
    }

    this.idleService.onTimeoutWarning$.subscribe((countdown) => {
      this.countdown = countdown;
      this.showModal = true;
    });

    this.idleService.onTimeout$.subscribe(() => {
      this.showModal = false;
      this.authService.logout();
    });

    this.router.events.subscribe((event: any) => {
    });
  }

  onStayActive() {
    this.idleService.resetTimer(); // ✅ Reanuda
    this.showModal = false;
  }
}
